import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';

const ServiceAuthAuditPage = lazy(
  () => import('~/features/service-auth/pages/service-auth-audit-page'),
);

export const Route = createFileRoute('/_authenticated/_tenant/platform/service-auth/audit')({
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <ServiceAuthAuditPage />
    </Suspense>
  ),
});
